<template>
  <div id="TCs" class="container-fluid px-0">
    <div class="main">
      <div class="page-header">
        <div class="page-title d-flex flex-column align-items-center">
          <img class="logo" src="/img/spectrum_life_logo_light.png" />
          <h2 class="brand-text mb-0">
            Terms of Use
          </h2>
        </div>
      </div>
      <div class="content">
        <div class="content-card">
          <ol v-if="!isSelfPay && !isIncludedInPlan" class="top-list mb-5">
            <li>
              <a href="#included-in-plan-services"
                >Included in your plan services</a
              >
            </li>
            <li><a href="#self-paid-services">Self-paid services</a></li>
          </ol>
          <div v-if="!isSelfPay">
            <h2
              v-if="!isSelfPay && !isIncludedInPlan"
              class="subheading"
              id="included-in-plan-services"
            >
              1. Included in your plan services:
            </h2>
            <p>
              This terms of service ("agreement") governs your use of and access
              to the services is provided by Spectrum.Life Limited, a registered
              company of Ireland. Spectrum Wellness Limited T/A Spectrum.Life
              ("Spectrum.Life"), the provider of this service (the "Service").
            </p>
            <p>
              1.1 SERVICES. Subject to all terms and conditions of this
              Agreement, Spectrum.Life will use commercially reasonable efforts
              to provide the Services. Access to these services is subject to
              have sufficient credits from your employer, a voucher or from a
              direct contribution to your wallet. These services are facilitated
              by a mixture of partners, and suitably qualified direct employees
              or contractors of Spectrum.Life. In the case of services provided
              directly by Spectrum.Life ('Direct Services'), Spectrum.Life is
              manages the end to end journey of your engagement with the
              Services. In the case of Services facilitated by partners
              ('Facilitated Services'), In order to improve your experience of
              the Services, Spectrum.Life will by the way of ongoing audits and
              performance management, aim to ensure that such partners are
              meeting their clinical standards and data protection obligations.
            </p>
            <div class="d-flex table">
              <div>
                <h4>Service Type</h4>
                <p>Mental Health Services</p>
              </div>
              <div>
                <h4>UK</h4>
                <p>Service provider is named on your booking confirmation</p>
              </div>
              <div>
                <h4>Ireland</h4>
                <p>Service provider is named on your booking confirmation</p>
              </div>
            </div>
            <p>
              1.2 CHANGES TO THE SERVICES. Spectrum.Life may also make
              commercially reasonable modifications to the Services from time to
              time without prior notice.
            </p>
            <p>
              1.3 LIMITATIONS. Spectrum.Life will not be responsible or liable
              for any failure in the Services or API to the extent such failure
              results from or directly attributable to (a) your Systems, (b)
              network, telecommunications or other service or equipment, (c)
              your products or services or third party products or services
              procured or provided by you, (d) your gross negligence or willful
              misconduct or the gross negligence or willful misconduct of third
              parties engaged by you, (e) any Force Majeure Event, (f) scheduled
              maintenance or (g) unauthorized access by third parties to the
              Services that results from Systems used by you to access the
              Services
            </p>
            <p>
              1.4 SYSTEMS. You shall obtain and operate all Systems needed to
              use the Services such as access to Video Conferencing links, and
              provide all corresponding backup, recovery and maintenance
              services. You shall ensure that all Systems are compatible with
              the Services.
            </p>
            <p>
              1.5 USE OF THE SERVICES. Your use of the Services is subject to
              your acknowledgement and agreement to the following: (a) All
              health related advice should be discussed with our physician or GP
              prior to you taking action (b) You should receive full
              professional advice on any actions you take resulting from advice
              received from the Services.
            </p>
            <p>
              1.6 FAIR USAGE. Spectrum.Life may implement certain policies to
              ensure fair and needed usage of the service takes place.
            </p>
            <p>
              1.7 NO IMPLIED LICENSE. Except for the limited rights and licenses
              expressly granted hereunder, no other license is granted to you,
              no other use is permitted and Spectrum.Life shall retain right,
              title and interest in and to the Services, the API and all updates
              and modifications thereto (including all intellectual property and
              proprietary rights embodied therein). You shall not take any
              action inconsistent with such rights.
            </p>
            <p>
              1.8 DISCLAIMER OF HEALTH ADVICE. Neither the Services, nor access
              to the Services via the SDK, nor any content provided via the
              Service, is a substitute for the advice of a User's own personal
              doctor or health professional. Spectrum.Life makes no warranty
              that use of the Services nor SDK should be construed as health
              advice on any health related, if prior consultation has not
              occurred with your own GP or Consultant.
            </p>
            <p>
              1.9 CANCELLATION TERMS. All appointments are subject to a 48 hour
              cancellation window prior to your appointment time, no refunds of
              credits can be applied if you cannot attend your appointment
              within 48 hours of your appointment window.
            </p>
            <p>
              1.10 LIMITED LIABILITY. In the case of Facilitated Services,
              Spectrum.Life does not make any representations or warranties with
              respect to these Service Providers or the quality of the
              healthcare services they may provide.
            </p>
            <p>
              1.11 USER DATA AND INTELLECTUAL PROPERTY RIGHTS. Any information
              that you upload or submit to us in connection with the Services or
              your Account, including but not limited to Protected Health
              Information (defined below), is referred to in this Agreement as
              "User Data". You retain all Intellectual Property Rights in your
              User Data, subject to the rights, licenses, and other terms of
              this Agreement. "Intellectual Property Rights" means copyrights,
              trademarks, service marks, trade dress, publicity rights, database
              rights, patent rights, and other intellectual property rights or
              proprietary rights recognized by law. You affirm, represent, and
              warrant that you own or have all necessary Intellectual Property
              Rights, licenses, consents, and permissions to use - and authorize
              Spectrum.Life to use - the User Data you provide in the manner
              described by this Agreement.
            </p>
            <p>
              1.12 APPLICABILITY TO SDK INTEGRATION. These terms are also
              applicable to any users utilizing the service through
              Spectrum.Life's SDK embeds into other client-partner applications.
              Users accessing the service through SDK integrations are subject
              to the same terms and conditions outlined in this Agreement.
            </p>
            <p>
              You agree that by providing any User Data in connection with the
              Services or your Account, you are granting Spectrum.Life a
              non-exclusive, worldwide, royalty-free, sublicensable, and
              transferable license to use, reproduce, distribute, prepare
              derivative works of, and display the User Data non-publicly and
              internally to Spectrum.Life for the purposes of providing the
              Services. You agree that the license includes the right to analyze
              and use any of your User Data for troubleshooting, debugging,
              testing, supporting, enhancing or developing services in
              connection with the Services and future improvements to the
              Services.
            </p>
          </div>
          <div v-if="!isIncludedInPlan">
            <h2
              v-if="!isSelfPay && !isIncludedInPlan"
              id="self-paid-services"
              class="subheading pt-5 mb-5"
            >
              2. Self-pay services:
            </h2>
            <h3 class="pt-0">1. Definitions</h3>
            <p>
              1.1 <b>"Services"</b> - Refers to the self-pay clinical and
              wellbeing offerings, including coaching sessions, neurodiversity
              assessments, digital mental health open ended digital therapy and
              single session consultations.
            </p>
            <p>
              1.2 <b>"User" or "You"</b> - Refers to any individual accessing or
              using the Services.
            </p>
            <p>
              1.3 <b>"Platform"</b> - Refers to the Simplyhealth app or web
              portal where Services are accessed.
            </p>
            <p>
              1.4 <b>"Clinician"</b> - Refers to qualified professionals
              providing the Services, such as psychologists, dietitians,
              advanced nurse practitioners, and mental health coaches.
            </p>
            <p>
              1.5 <b>"Spectrum.Life"</b> - SPECTRUM Wellness UK Limited t/a
              Spectrum.Life, a company incorporated in England and Wales under
              number 11815511 whose registered office is at Huckletree, Ancoats,
              9 Great Ancoats St, Manchester, United Kingdom, M4 5AD
              (Supplier/Spectrum Life).
            </p>
            <h3>2. Services Overview</h3>
            <p>
              2.1 Spectrum.Life delivers a range of clinical and wellbeing
              services to Simplyhealth users through the Simplyhealth platform.
              While Simplyhealth provides the platform for accessing these
              services, Spectrum.Life is responsible for the delivery of the
              services, adhering to established clinical and ethical standards
              such as ISO90001, BACP, and NICE guidelines.
            </p>
            <p>
              2.2 The Services include a range of self-pay clinical and
              wellbeing services, including:
            </p>
            <ul>
              <li>
                Sub-clinical and clinical coaching sessions (e.g., mental
                health, sleep, gut health, parenting).
              </li>
              <li>
                Neurodiversity assessment pathways for adults and children.
              </li>
              <li>
                Open-ended digital mental health therapy for adults and
                children.
              </li>
              <li>
                Services are delivered remotely through video consultation.
              </li>
            </ul>
            <p>
              2.3 The exact services and naming are subject to updates as agreed
              upon between Simplyhealth and Spectrum.Life.
            </p>
            <p>
              2.4 Services are delivered by qualified professionals, including
              mental health coaches, advanced nurse practitioners,
              psychologists, dietitians, and other licensed clinicians.
            </p>
            <p>
              2.5 Our services are not substitutes for emergency medical care.
              For emergencies, contact your local emergency services (e.g.,
              111/999) or visit the nearest hospital.
            </p>
            <h3>3. Service Delivery</h3>
            <p>
              3.1 Spectrum.Life will provide the Services using all the due
              skill, care and diligence and to the level expected from an
              experienced provider of the Services and in accordance with such
              quality standards as can be found in accordance with ISO90001,
              BACP and EAPA, CQC, NICE, HCPC , BDA, AFM, BPS, NMC, ACP and any
              other applicable quality standards and maintain such
              accreditation.
            </p>
            <p>
              3.2 For services involving children and young persons, parental or
              guardian involvement is required for any assessments,
              consultations, or therapeutic interventions.
            </p>
            <p>
              3.3 All appointments are delivered remotely via the Simplyhealth
              platform using video communication.
            </p>
            <p>
              3.4. Initial and follow-up consultations will occur as per the
              service structure agreed between Spectrum.Life and the User.
            </p>
            <p>
              3.5 Mental health and sleep coaching pathways consist of three
              sessions: an introductory session (45 minutes), a mid-point
              session (30 minutes), and a final session (30 minutes).
            </p>
            <p>
              3.6 Neurodiversity assessments involve an initial consultation
              followed by referral through to a detailed assessment, where
              clinically appropriate, including diagnosis and outcome report.
              These assessments are conducted by a multidisciplinary team. For
              UK residents, one adult holding parental responsibility/legal
              guardianship for a child or young person needs to provide their
              consent for engagement with our Neurodiversity service. This is
              gained through a consent form that is within the platform.
            </p>
            <p>
              3.7 Single Coaching sessions are 30 minutes. The user is
              responsible for booking any follow up sessions.
            </p>
            <p>
              3.8 Open Ended Therapy sessions are 50 minutes per appointment.
              The decision on the number of sessions needed is decided between
              the end user and the Clinician. In the case of a minor, informed
              consent will be obtained from the parent or legal guardian of the
              client during the booking process on the App.
            </p>
            <h3>4. Service Eligibility and Appropriateness</h3>
            <p>
              4.1 The Services shall only be available for members of
              Simplyhealth with an active membership, including all registered
              dependents on a member's plan and subject to age restrictions.
            </p>
            <p>
              4.2 Spectrum.Life reserves the right to decline access to services
              if, during the booking process or subsequent consultations, it is
              determined that the user does not meet the Service's clinical or
              eligibility criteria or falls within the outlined exclusion
              criteria. This decision is made by Spectrum to ensure the safety,
              effectiveness, and appropriateness of the Service for the User.
            </p>
            <p>
              Examples of situations where access may be declined include, but
              are not limited to:
            </p>
            <ul>
              <li>The User's needs require specialised or emergency care.</li>
              <li>
                The User presents with conditions or circumstances explicitly
                listed in the exclusion criteria for the Service.
              </li>
              <li>
                The User is unable to engage meaningfully with the Service due
                to factors such as acute distress, unstable physical or mental
                health, or other barriers to participation.
              </li>
            </ul>
            <p>
              In such cases, Spectrum.Life will make every effort to guide the
              User towards appropriate alternative services or resources and
              provide signposting to relevant support where applicable.
            </p>
            <h4 class="mb-4">4.3 Exclusion Criteria:</h4>
            <h4 class="underline">Mental Health Coaching</h4>
            <p>
              Mental Health coaching is designed to support individuals
              experiencing mild to moderate distress, it is best suited towards
              those looking to improve their overall wellbeing. There are some
              exclusions to this service:
            </p>
            <ul>
              <li>Children or Adolescents under the age of 18.</li>
              <li>
                Coaching is not appropriate for individuals currently dealing
                with severe or complex mental health diagnoses that require a
                clinical level of care.
              </li>
              <li>
                Coaching is not a replacement for psychological
                counselling/therapy or psychiatric treatment.
              </li>
              <li>
                Coaching does not provide crisis intervention or emergency
                support. Those in immediate distress or facing urgent mental
                health difficulties should contact emergency services for prompt
                assistance. Coaching services are not a replacement for crisis
                support or a GP.
              </li>
              <li>
                For individuals experiencing substance dependence or addiction,
                specialised addiction support or treatment programmes would be
                better suited to support these types of difficulties.
              </li>
            </ul>
            <h4 class="underline">Sleep coaching</h4>
            <p>
              Sleep coaching is designed for individuals who want practical
              support to improve their sleep quality and habits. There are some
              exclusions to this service:
            </p>
            <ul>
              <li>Children or Adolescents under the age of 18.</li>
              <li>
                Users struggling with a clinical sleep disorder: For conditions
                like insomnia or sleep apnoea, a medical professional would be
                more suitable.
              </li>
              <li>
                Immediate or crisis support is needed: for urgent situations,
                the in-the-moment support or a GP may be more a more suitable
                resource.
              </li>
              <li>
                Users seeking therapy for underlying emotional or psychological
                issues.
              </li>
            </ul>
            <h4 class="underline">Parenting single session consultation</h4>
            <p>
              Single session parent coaching is ideal for brief,
              solution-focused support to help parents navigate immediate
              concerns or common parenting challenges. There are some exclusions
              to this service:
            </p>
            <ul>
              <li>Children or adolescents under the age of 18.</li>
              <li>
                If you are seeking longer term support. For ongoing challenges
                that require deeper exploration or continuous guidance,
                open-ended therapy would be recommended.
              </li>
              <li>
                If you are managing complex family dynamics: for issues
                involving trauma, severe behavioural concerns or significant
                mental health challenges, ongoing therapy provides a more
                comprehensive approach to explore and address these
                complexities.
              </li>
              <li>
                If you are experiencing a family crisis: parent coaching is not
                intended for crisis intervention. If you're dealing with an
                immediate, serious family crisis, please reach out to a crisis
                support service or contact in-the-moment support to learn what
                other options may be more suitable.
              </li>
            </ul>
            <h4 class="underline">Menopause single session consultation</h4>
            <p>
              The menopause single sessions are designed for women experiencing
              menopausal symptoms who seek personalised, nurse-led guidance to
              manage their transition effectively, improve daily well-being, and
              explore non-pharmacological lifestyle adjustments or treatment
              options, with exclusions for unmanaged severe symptoms or
              conditions requiring urgent medical care. There are some
              exclusions to this service:
            </p>
            <ul>
              <li>Children or adolescents under the age of 18.</li>
              <li>Unmanaged severe menopausal symptoms.</li>
              <li>Untreated mental health conditions.</li>
              <li>Unexplained abnormal post-menopausal bleeding.</li>
              <li>Desire for medication or referral.</li>
            </ul>
            <h4 class="underline">Gut health and healthy diet</h4>
            <p>
              The gut health and healthy diet single sessions are suitable for
              those seeking personalised guidance to address gut-related
              concerns, optimise digestion, and develop sustainable dietary
              habits. There are some exclusions to this service:
            </p>
            <ul>
              <li>Children or adolescents under the age of 16.</li>
              <li>Pregnant or breastfeeding women.</li>
              <li>Persons undergoing specialised care or treatment.</li>
              <li>Need for clinical diagnostics or treatment.</li>
              <li>
                Acute conditions requiring immediate care including eating
                disorders.
              </li>
              <li>Desire for medication or referral.</li>
            </ul>
            <h4 class="underline">Weight management</h4>
            <p>
              The weight management single sessions are designed for individuals
              seeking personalised support to achieve sustainable weight loss,
              maintenance, or gain through tailored nutrition and lifestyle
              strategies. There are some exclusions to this service:
            </p>
            <ul>
              <li>Children and adolescents under the age of 16.</li>
              <li>Eating disorders.</li>
              <li>Desire for medication or referral.</li>
              <li>Pregnant or breastfeeding women.</li>
              <li>Need for clinical diagnostics or treatment.</li>
            </ul>
            <h4 class="underline">Neurodiversity services</h4>
            <p>
              The neurodiversity services are designed for individuals seeking
              assessments for autism, ADHD, or combined autism and ADHD through
              a structured, multidisciplinary approach to provide clear
              diagnostic outcomes and recommendations. There are some exclusions
              to this service:
            </p>
            <ul>
              <li>Children under the age of 7.</li>
              <li>
                Children not covered under your membership with Simplyhealth.
              </li>
              <li>
                Individuals seeking re-evaluation of existing diagnoses without
                clinical justification.
              </li>
              <li>Those with unstable physical or mental health conditions.</li>
              <li>
                Individuals who are not able to receive, interpret, and form
                coherent understanding of information communicated by others
                through sentence level speech or other forms of sentence level
                communication (such as written text).
              </li>
              <li>
                Those who are not able to express their thoughts, emotions, and
                ideas at a sentence level using their preferred mode(s) of
                communication, whether through spoken language, written methods,
                or other forms of alternative or augmentative communication.
              </li>
            </ul>
            <h4 class="underline">Open ended digital therapies</h4>
            <p>
              The open-ended digital therapy services are designed for
              individuals seeking ongoing, flexible mental health support from
              qualified therapists to address mild to moderate emotional
              challenges and improve overall well-being. There are some
              potential exclusions to this service.
            </p>
            <ul>
              <li>Children or adolescents under the age of 6.</li>
              <li>
                Children not covered under your membership with Simplyhealth.
              </li>
              <li>
                Individuals with severe mental health conditions requiring
                crisis intervention, clinical treatment, or psychiatric care.
              </li>
              <li>Must not have a plan and/or intent related to suicide.</li>
              <li>
                No attempts to end life have been made in the last 12 months.
              </li>
              <li>
                Must not have frequent self-harming requiring medical attention.
              </li>
              <li>Must not have current alcohol or drug dependency.</li>
              <li>
                Must not be acutely unwell/distressed to the extent they cannot
                participate in psychological intervention.
              </li>
              <li>
                If acute psychosis or an eating disorder is the primary need,
                the service may not be appropriate. In such cases, a more
                specialised approach tailored to these conditions, such as
                psychiatric treatment, medical management, or specialised
                therapy programs, is often recommended. Active eating disorders
                often require a multidisciplinary approach, including medical
                monitoring, nutritional rehabilitation, and specialised
                therapeutic interventions tailored to the condition.
              </li>
              <li>
                Must not have concerns about the individual or environment that
                requires a physical/face-to-face assessment.
              </li>
              <li>
                Must not be in a situation that is psychologically unsafe, for
                example current domestic violence or intimate partner abuse.
              </li>
              <li>
                Must not be involved in any active criminal investigation or
                currently on a child protection plan.
              </li>
              <li>
                Additional learning or support needs that affects participation
                in psychological intervention.
              </li>
              <li>
                Child/Young person in Looked After Care where the placement
                duration has been less than 6 months.
              </li>
            </ul>
            <h4>
              4.4 Geographic Limitations:
            </h4>
            <p>
              Services are currently offered to UK residents or UK territory
              residents.
            </p>
            <h3>5. User Responsibilities</h3>
            <p>
              5.1 Users must provide to Spectrum accurate and complete personal
              and medical information to ensure appropriate and effective
              service delivery.
            </p>
            <p>
              5.2 Users are expected to follow the recommendations provided by
              the assigned clinician or coach. Failure to do so may impact the
              clinical outcome or the value derived from the Service.
            </p>
            <p>
              5.3 Users are responsible for managing appointment schedules and
              notifying Spectrum promptly in case of cancellations or
              rescheduling needs.
            </p>
            <p>
              5.4 Parent (s) or guardian (s) will be responsible for providing
              supervision of children and young people engaging with our service
              and remain within the same environment to ensure safety; they will
              also be required to attend sessions that they have been requested
              to attend.
            </p>
            <p>
              5.5 Users are expected to engage with Clinicians respectfully and
              professionally. The following behaviours will not be tolerated:
            </p>
            <ul>
              <li>
                Abusive, aggressive, or threatening language or behaviour,
                whether verbal, written, or otherwise.
              </li>
              <li>
                Discrimination or harassment on the basis of race, gender,
                sexual orientation, religion, disability, or any other protected
                characteristic.
              </li>
              <li>
                Persistent non-compliance with recommendations or service
                guidelines that disrupt service delivery.
              </li>
            </ul>
            <p>5.6 Consequences of Unacceptable Behaviour</p>
            <ul>
              <li>
                Spectrum.Life and Simplyhealth reserve the right to:
                <ul>
                  <li>
                    Immediately terminate or suspend services if abusive or
                    unacceptable behaviour is exhibited toward clinicians,
                    administrative staff, or support teams.
                  </li>
                  <li>Refuse further appointments.</li>
                  <li>
                    Report serious incidents to appropriate authorities or
                    regulatory bodies if required by law.
                  </li>
                </ul>
              </li>
            </ul>
            <h3>
              6. Payment Terms
            </h3>
            <p>
              6.1 Services are self-pay, and fees are payable upfront directly
              to Spectrum via the Simplyhealth platform using debit/credit cards
              or other supported payment methods.
            </p>
            <p>
              6.2 Refunds are subject to the cancellation policy outlined below.
            </p>
            <p>
              For queries regarding refunds on coaching services please email
              <a href="mailto:coachingappointments@spectrum.life"
                >coachingappointments@spectrum.life</a
              >
            </p>
            <p>
              For queries regarding refunds on neurodiversity and open-ended
              digital therapy services please email
              <a href="mailto:appointments@spectrum.life"
                >appointments@spectrum.life</a
              >
            </p>
            <h3>
              7. Cancellations and Refunds
            </h3>
            <p>
              7.1 Appointment cancellations must be communicated at least 24
              hours in advance.
            </p>
            <p>
              7.2 Refunds or rescheduling will be processed in accordance with
              Spectrum.Life's Cancellation and Rescheduling policy and clinical
              appropriateness.
            </p>
            <p>
              7.3 A cancellation fee of 25% of the session cost applies for
              cancellations with less than 24 hours' notice. The remaining 75%
              will be refunded to the card used for booking within 3-5 business
              days.
            </p>
            <p>
              7.4 A missed appointment (Did Not Attend) will result in a 50%
              charge, with the remaining 50% refunded to the card used for
              booking within 3-5 business days.
            </p>
            <p>
              7.5 Our Cancellation and Rescheduling policy can be found
              <RouterLink to="/cancellation-policy" target="_blank"
                >here</RouterLink
              >.
            </p>
            <h3>
              8. Complaints and Feedback
            </h3>
            <p>
              8.1 Clinical and wellbeing complaints will be managed by
              Spectrum.Life. Submit details via email to
              <a href="mailto:simplyhealth@spectrum.life"
                >simplyhealth@spectrum.life</a
              >
            </p>
            <p>
              8.2 All complaints will be acknowledged within one (1) working day
              and resolved within ten (10) working days unless further
              investigation and, or consent is required.
            </p>
            <p>
              8.3 Spectrum.Life will forward all complaints and back to
              Simplyhealth's Customer Relations at
              <a href="mailto:customerrelations@simplyhealth.co.uk"
                >customerrelations@simplyhealth.co.uk</a
              >
              if the complaints/issues are not about the service and are related
              specifically to the Simplyhealth Product/Policy.
            </p>
            <h3>
              9. Clinical Standards and Safeguarding
            </h3>
            <p>
              9.1 Services are delivered in accordance with regulatory and
              clinical standards follows; as ISO90001, BACP, EAPA, CQC, and NICE
              guidelines.
            </p>
            <p>
              9.2 A safeguarding board is maintained to ensure the safety and
              wellbeing of Users, and practitioners are trained in safeguarding
              protocols.
            </p>
            <h3>
              10. Intellectual Property Rights
            </h3>
            <p>
              10.1 All content, materials, and resources provided during the
              sessions or on the platform remain the intellectual property of
              Simplyhealth or Spectrum.Life.
            </p>
            <p>
              10.2 Users may not reproduce, distribute, or share any materials
              without prior written consent.
            </p>
            <h3>
              11. Third-Party Services and Links
            </h3>
            <p>
              11.1 The platform may integrate with third-party services, such as
              payment gateways or hosting other service providers. While
              Spectrum.Life strive to ensure a seamless experience,
              Spectrum/Life are not responsible for issues arising from these
              external systems. Users are advised to review and adhere to the
              terms and conditions, privacy policies, and any other applicable
              policies of third-party services before using them.
            </p>
            <p>
              11.2 Links to external websites that may be provided are for
              informational purposes only and do not constitute endorsements.
              Spectrum.Life do not control or assume responsibility for the
              content, policies, or practices of third-party websites. Users
              should review the terms of use and policies of any external sites
              they choose to access.
            </p>
            <h3>
              12. Termination of Services
            </h3>
            <p>
              12.1 Simplyhealth and Spectrum.Life reserve the right to suspend
              or terminate services if these terms are violated or misuse is
              detected.
            </p>
            <p>
              12.2 Users may discontinue using the Services at any time, but
              cancellations must adhere to the
              <RouterLink to="/cancellation-policy" target="_blank"
                >Refund and Rescheduling policy</RouterLink
              >.
            </p>
            <h3>
              13. No Medical Emergency Services Disclaimer
            </h3>
            <p>
              13.1 Our services are not substitutes for emergency medical care.
              For emergencies, contact your local emergency services (e.g.,
              111/999) or visit the nearest hospital.
            </p>
            <h3>
              14. Privacy and Data Protection
            </h3>
            <p>
              14.1 All personal and clinical data is handled per applicable data
              protection laws, including GDPR and HIPAA.
            </p>
            <p>
              14.2 Data is retained securely for up to seven years, as required
              by law.
            </p>
            <p>
              14.3 Transfers of personal data to third-party providers are
              encrypted and limited to essential purposes.
            </p>
            <h3>
              15. Governing Law and Dispute Resolution
            </h3>
            <p>
              15.1 These terms are governed by the laws of England and Wales.
            </p>
            <p>
              15.2 Disputes will first be resolved through mediation before
              escalation to legal proceedings.
            </p>
            <h3>
              16. Force Majeure
            </h3>
            <p>
              16.1 Simplyhealth and Spectrum.Life are not liable for delays or
              failures caused by circumstances beyond their control, including
              natural disasters or technical failures.
            </p>
            <h3>
              17. Amendments to Terms
            </h3>
            <p>
              17.1 Simplyhealth and Spectrum.Life reserve the right to update
              these Terms and Conditions.
            </p>
            <p>
              17.2 Users will be notified of significant changes via email or
              platform notifications at least 30 days before implementation.
            </p>
            <h3>
              18. Indemnification
            </h3>
            <p>
              18.1 Users agree to indemnify Simplyhealth and Spectrum.Life
              against liabilities arising from misuse of the services or
              violation of these terms.
            </p>
            <h3>
              19. Contact Information
            </h3>
            <h4 class="mb-4">
              For GDPR - related or privacy concerns
            </h4>
            <p>Spectrum.Life</p>
            <ul>
              <li>
                Email:
                <a href="mailto:gdprspectrumlife@spectrum.life"
                  >gdprspectrumlife@spectrum.life</a
                >
              </li>
              <li>
                Address: Spectrum Life, Trinity Ward, 95 Merrion Square West,
                Dublin
              </li>
            </ul>
            <p>Simplyhealth</p>
            <ul>
              <li>
                Email
                <a href="mailto:thedataprotectionofficer@simplyhealth.co.uk"
                  >thedataprotectionofficer@simplyhealth.co.uk</a
                >
              </li>
              <li>
                Address: Simplyhealth Guidance Limited, Anton House, Chantry
                Street, Andover, Hampshire, SP10 1DE
              </li>
            </ul>
            <h4 class="mb-4">General Support or Customer Service</h4>
            <p>Spectrum.Life</p>
            <p>Suitable for questions about services or payments</p>
            <p>
              For all Coaching services please email
              <a href="mailto:coachingappointments@spectrum.life"
                >coachingappointments@spectrum.life</a
              >
            </p>
            <p>
              For neurodiversity and open-ended digital therapy services please
              email
              <a href="mailto:appointments@spectrum.life"
                >appointments@spectrum.life</a
              >
            </p>
            <ul>
              <li>
                Address: Spectrum Life, Trinity Ward, 95 Merrion Square West,
                Dublin
              </li>
            </ul>
            <h4 class="mb-4">
              Service Complaint
            </h4>
            <p>Spectrum.Life</p>
            <p>Suitable for complaints about services or payments</p>
            <ul>
              <li>
                Email:
                <a href="mailto:simplyhealth@spectrum.life"
                  >simplyhealth@spectrum.life</a
                >
              </li>
              <li>
                Address: Spectrum Life, Trinity Ward, 95 Merrion Square West,
                Dublin
              </li>
            </ul>
            <h4 class="mb-4">Customer Service for your Simplyhealth Plan</h4>
            <p>Simplyhealth</p>
            <p>
              Suitable only for general queries relating to your Simplyhealth
              Plan or Policy
            </p>
            <ul>
              <li>
                The quickest way to get in touch is to talk to Simplyhealth's
                digital assistant, Sam, by clicking the bottom right of the
                screen on
                <a href="https://www.simplyhealth.co.uk/contact-us/personal"
                  >https://www.simplyhealth.co.uk/contact-us/personal</a
                >
              </li>
              <li>
                Email:
                <a href="mailto:customerservices@simplyhealth.co.uk"
                  >customerservices@simplyhealth.co.uk</a
                >
              </li>
              <li>
                Address: Simplyhealth Guidance Limited, Anton House, Chantry
                Street, Andover, Hampshire, SP10 1DE
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TCs",
  props: ["type"],
  computed: {
    isSelfPay() {
      return this.$route.params?.type === "self-pay";
    },
    isIncludedInPlan() {
      return this.$route.params?.type === "included-in-plan";
    }
  }
};
</script>

<style lang="less">
#TCs {
  .main {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .page-header {
    padding: 60px 20px 20px;
    background-color: #fbfafa;
  }

  .logo {
    max-width: 350px;
    width: 100%;
    padding-bottom: 50px;
  }

  .page-title {
    h2 {
      text-align: center;
      font-size: 3.8rem;
      letter-spacing: normal;
      font-family: "PlusJakartaSansBold";
      margin-bottom: 0;
    }
  }

  .subheading {
    font-size: 2.8rem;
    text-align: left;
    margin-bottom: 20px;
  }

  .table {
    gap: 6px;
  }

  .content {
    flex: 1 1 100%;
    padding: 20px 20px 60px;
    background-color: #fbfafa;
  }

  .content-card {
    height: 100%;
    background: #ffffff;
    max-width: 1000px;
    padding: 40px 60px 30px;
    margin: 0 auto;
    border-radius: 16px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: #212529;
      font-family: "PlusJakartaSansBold";
    }

    h3 {
      font-size: 2.2rem;
      letter-spacing: 0;
      padding: 32px 0 0;
      margin: 0 0 24px;
    }

    h4 {
      font-size: 1.6rem;
      letter-spacing: 0;
      padding: 0;
      margin: 0 0 4px;

      &.underline {
        text-decoration: underline;
      }
    }

    p {
      color: #212529;
      padding: 0;
      margin: 0 0 16px;
      font-size: 1.6rem;
    }

    ul,
    ol {
      color: #212529;
      margin: 0 0 16px;
    }

    li {
      color: #212529;
      font-size: 1.6rem;
    }

    b {
      font-family: "PlusJakartaSansBold";
    }

    a {
      color: #3c16f9;

      &:hover,
      &:active {
        color: #3c16f9;
      }
    }
  }

  .top-list {
    li {
      margin-bottom: 6px;
    }

    a {
      color: #3c16f9;

      &:hover,
      &:active {
        color: #3c16f9;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    .content-card {
      padding: 30px 20px;
    }
  }
}
</style>
